import { IAISummaryEntryPointBlock } from '../../types/newbuildingsCompare';
import { IApplicationState } from '../../types/redux';

export function selectAiSummaryEntryPoint(state: IApplicationState): IAISummaryEntryPointBlock | undefined {
  return state.newbuildingsComparison?.aiSummaryEntryPoint;
}
